import { render, staticRenderFns } from "./desuLimitClassify.vue?vue&type=template&id=002f4a07&scoped=true"
import script from "./desuLimitClassify.vue?vue&type=script&lang=js"
export * from "./desuLimitClassify.vue?vue&type=script&lang=js"
import style0 from "./desuLimitClassify.vue?vue&type=style&index=0&id=002f4a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f4a07",
  null
  
)

export default component.exports